import React from 'react';
import styles from '../asset/scoreStatisticBoard.module.scss';
import DotIndicator from './DotIndicator';
import UserIcon from './UserIcon';

const CurrentMilestone = ({ score, position }) => (
    <div className={styles.currentMilestone} style={{ left: position }}>
        <div className={styles.currentScoreWrapper}>
            <span className={styles.currentScore}>{score}</span>
            <UserIcon className={styles.userAvatar} />
        </div>
        <div className={styles.currentIndicator}>
            <DotIndicator count={4} color="#220EC9" size={6} />
            <span className={styles.currentLabel}>Now</span>
        </div>
    </div>
);

export default CurrentMilestone;
